import { useI18n } from "vue-i18n";

export default () => useI18n();
